'use client';
import React from 'react';
import { CategoryDetails, EventCarousel } from './components';
import { cn } from '@/lib';

interface EventsByCategoryProps {
  heading: string;
  subHeading: string;
  colorScheme: 'dark' | 'light';
  data: any;
  buttonRedirect?: string;
  className?: React.ComponentProps<'div'>['className'];
  onEndReached?: () => void;
  hasMore?: boolean;
  loadingMore?: boolean;
}

export default function EventsByCategory({
  colorScheme,
  data,
  heading,
  className = '',
  buttonRedirect,
  subHeading,
  onEndReached,
  hasMore,
  loadingMore,
}: EventsByCategoryProps): React.ReactNode {
  const carouselRef = React.useRef<{
    nextSlide: () => void;
    prevSlide: () => void;
  }>(null);

  return (
    <section
      className={cn('flex flex-col gap-6 pt-10 sm:pt-12', className, {
        'bg-gray-900 text-white': colorScheme === 'dark',
        '': colorScheme === 'light',
      })}
    >
      <section className='mx-auto w-full max-w-7xl sm:px-4'>
        <CategoryDetails
          heading={heading}
          subHeading={subHeading}
          colorScheme={colorScheme}
          nextSlide={carouselRef.current?.nextSlide}
          prevSlide={carouselRef.current?.prevSlide}
          buttonRedirect={buttonRedirect}
        />

        <div className='pb-10 sm:px-4 sm:pb-6'>
          <EventCarousel
            ref={carouselRef}
            events={data ? data : null}
            onEndReached={onEndReached}
            hasMore={hasMore}
            loadingMore={loadingMore}
          />
        </div>
      </section>
    </section>
  );
}
